<template>
  <div class="border round-6px w-100 pt-3">
    <div class="d-flex px-2 pb-2">
      <p
        class="mb-0 px-2 py-1 pointer"
        :class="{ 'text-primary bold': activeTab === 'all' }"
        @click="activeTab = 'all'"
      >
        Danh sách
      </p>
      <p
        class="mb-0 px-2 py-1 pointer"
        :class="{ 'text-primary bold': activeTab === 'selected' }"
        @click="activeTab = 'selected'"
      >
        Đã chọn ({{ selectedOptions.length }})
      </p>
    </div>

    <div class="py-1 px-5px d-flex justify-content-end">
      <input
        ref="searchInput"
        class="form-control form-control-sm h-40px p-2 font-12 box-120"
        :value="searchKey"
        :disabled="disabled"
        :placeholder="placeholder || 'Tìm kiếm'"
        @input="onSearchInput"
      />

      <p
        v-if="activeTab === 'all'"
        class="text-primary bold p-2"
        :style="{ 'pointer-events': disabled ? 'none' : 'auto' }"
        @click="selectAllDisplayed"
      >
        <i v-if="loading" class="fa fa-spinner fa-spin mr-1" />
        Chọn hết
      </p>
    </div>

    <div style="max-height: 160px; overflow: auto">
      <div
        v-for="option in currentOptions"
        :key="option.id"
        class="pt-1 pl-15px"
      >
        <check-box
          :value="isSelected(option.id)"
          :title="option.name"
          :disabled="disabled"
          @change="toggleOption(option.id)"
        />
      </div>

      <p
        v-if="!currentOptions.length"
        class="text-muted font-12 px-3 pb-2 mb-0"
      >
        Không có dữ liệu
      </p>
    </div>
  </div>
</template>

<script>
import CheckBox from "./CheckBox.vue"

export default {
  name: "MultiSelectInput",
  components: {
    CheckBox,
  },
  // props: {
  //   value: Array,
  //   list: {
  //     type: Array,
  //     default: () => [],
  //   },
  //   disabled: Boolean,
  //   searchFunction: Function,
  //   placeholder: String,
  // },
  props: [
    "value",
    "list",
    "disabled",
    "searchFunction",
    "placeholder",
  ],
  data() {
    return {
      activeTab: "all",
      searchKey: "",
      localList: [],
      loading: false,
      searchRef: null,
    }
  },
  computed: {
    displayedOptions() {
      const keyword = this.$changeAlias(this.searchKey || "")
      return (this.localList || []).filter((option) => {
        if (!keyword) return true
        return this.$changeAlias(
          `${option.name || ""}${option.search || ""}`,
        ).includes(keyword)
      })
    },
    selectedOptions() {
      const optionMap = new Map()

      ;[...(this.list || []), ...(this.localList || [])].forEach((item) => {
        if (!item || item.id === undefined || item.id === null) return
        optionMap.set(item.id, { ...item })
      })

      return (this.value || []).map((item) => {
        const id = this.getSelectedCode(item)
        const option = optionMap.get(id)

        if (option) {
          return option
        }

        return {
          id,
          name: this.getSelectedName(item),
        }
      })
    },
    currentOptions() {
      return this.activeTab === "selected"
        ? this.selectedOptions
        : this.displayedOptions
    },
  },
  watch: {
    list: {
      immediate: true,
      handler(list) {
        this.localList = (list || []).map((item) => ({ ...item }))
      },
    },
  },
  beforeDestroy() {
    if (this.searchRef) {
      clearTimeout(this.searchRef)
    }
  },
  methods: {
    async fetchOptions(keyword = "") {
      if (!this.searchFunction) return

      this.loading = true
      try {
        const result = await this.searchFunction(keyword)
        this.localList = (result || []).map((item) => ({ ...item }))
      } finally {
        this.loading = false
      }
    },
    focus() {
      if (this.$refs.searchInput) {
        this.$refs.searchInput.focus()
      }
    },
    getSelectedCode(item) {
      if (item && typeof item === "object") {
        return item.code ?? item.id
      }
      return item
    },
    getSelectedName(item) {
      if (item && typeof item === "object") {
        return item.value || item.name || item.code || item.id
      }
      return item
    },
    buildSelectedItem(option = {}) {
      return {
        code: option.id,
        value: option.name,
      }
    },
    isSelected(id) {
      return (this.value || []).some((item) => this.getSelectedCode(item) === id)
    },
    emitChange(value) {
      this.$emit("input", value)
      this.$emit("change", value)
      this.$emit("changeOption", value)
    },
    toggleOption(id) {
      const nextValue = [...(this.value || [])]
      const currentIndex = nextValue.findIndex(
        (item) => this.getSelectedCode(item) === id,
      )

      if (currentIndex > -1) {
        nextValue.splice(currentIndex, 1)
      } else {
        const option = (this.localList || []).find((item) => item.id === id)
        nextValue.push(this.buildSelectedItem(option || { id, name: id }))
      }

      this.emitChange(nextValue)
    },
    selectAllDisplayed() {
      if (this.disabled) return
      this.emitChange(
        this.displayedOptions.map((option) => this.buildSelectedItem(option)),
      )
    },
    onSearchInput(event) {
      this.searchKey = event.target.value

      if (!this.searchFunction) {
        return
      }

      if (this.searchRef) {
        clearTimeout(this.searchRef)
      }

      this.searchRef = setTimeout(async () => {
        await this.fetchOptions(this.searchKey)
      }, 500)
    },
  },
  mounted() {
    this.fetchOptions()
  },
}
</script>
